module.exports = __webpack_public_path__ + "img/Lupinus_angustifolius.bf02ea3d.jpg";